import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import classNames from "classnames";

const Header = () => {
  const history = useHistory();
  const location = useLocation();

  // Determine if active
  const isAllFacilities = location.pathname === "/app/facilities/allFacilities";
  const isMyFacilities = location.pathname === "/app/facilities/myFacilities";

  return (
    <div className="flex items-center justify-between py-9 bg-[var(--color-glass-dark)]">
      {/* Navigation Tabs */}
      <div className="flex items-center gap-6 ml-1">
        <h5
          id="all-facilities-h5-link"
          data-cy="all-facilities-h5-link"
          className={classNames(
            "tw-heading-5 cursor-pointer",
            isAllFacilities ? "text-[var(--color-gray-800)]" : "text-[var(--color-gray-400)]"
          )}
          onClick={() => history.push("/app/facilities/allFacilities")}
        >
          All Facilities
        </h5>

        <h5
          id="my-facilities-h5-link"
          data-cy="my-facilities-h5-link"
          className={classNames(
            "tw-heading-5 cursor-pointer",
            isMyFacilities ? "text-[var(--color-gray-800)]" : "text-[var(--color-gray-400)]"
          )}
          onClick={() => history.push("/app/facilities/myFacilities")}
        >
          My Facilities
        </h5>
      </div>
    </div>
  );
};

export default Header;